export const logos = [
  {
    img:
      'https://a.bmstatic.com/iu/159/241/bookmate_logomark-a50cdeacb649382e3c6fdd75f8817e5f.svg',
    links: {
      AI:
        'https://a.bmstatic.com/iu/161/254/bookmate-ee9f06da1e65173b7c42742ecee78a45.zip',
      PNG:
        'https://a.bmstatic.com/iu/161/254/bookmate-b7c08aad442ac83730eb3bedac0cfc32.zip',
    },
  },
  {
    img:
      'https://a.bmstatic.com/iu/98/119/preview_horizontal_mono-5839c0a3e99da2a4ece27ffb69f84d2e.png',
    links: {
      AI:
        'https://a.bmstatic.com/iu/161/254/bookmate-ab14ee37ba91662b0c792823d6cd9408.zip',
      PNG:
        'https://a.bmstatic.com/iu/161/254/bookmate-ae644849b72f32c0954e27adeb8cc54e.zip',
    },
  },
]

export const screensRu = [
  {
    img:
      'https://a.bmstatic.com/iu/243/106/bookmate_library_RU-bf346decfd31e9644f31c7bd1307adc9.png',
    links: {
      PDF:
        'https://a.bmstatic.com/iu/188/105/bookmate_library_RU-82035b45988d87e810706d5c22f2b3da.pdf',
      PNG:
        'https://a.bmstatic.com/iu/243/106/bookmate_library_RU-66eb1527cc514232d59999c14ffc20e4.png',
    },
  },
  {
    img:
      'https://a.bmstatic.com/iu/169/181/bookmate_library_and_reader_diagonal_RU-74c9c9b80eed97edb84bc05b47be6fd2.png',
    links: {
      PDF:
        'https://a.bmstatic.com/iu/70/75/bookmate_library_and_reader_RU-d3c737befbd67ee6f89592ea32f460ca.pdf',
      PNG:
        'https://a.bmstatic.com/iu/125/76/bookmate_library_and_reader_RU-760b2406d8fa18bd970e9d349616e179.png',
    },
  },
  {
    img:
      'https://a.bmstatic.com/iu/125/76/bookmate_library_and_reader_RU-71040fab395e97111e9e4b356192cb04.png',
    links: {
      PDF:
        'https://a.bmstatic.com/iu/114/180/bookmate_library_and_reader_diagonal_RU-67e05a759a4239facb37938420a841fe.pdf',
      PNG:
        'https://a.bmstatic.com/iu/169/181/bookmate_library_and_reader_diagonal_RU-65806bbc2b60de0cdeb27c1130d55094.png',
    },
  },
]

export const screensEn = [
  {
    img:
      'https://a.bmstatic.com/iu/6/169/bookmate_library_ENpng-ae0f807e17b7c6c22bbccbf69d0de6d7.png',
    links: {
      PDF:
        'https://a.bmstatic.com/iu/34/197/bookmate_library_EN-d047dbf00ab9521d70213c7aec1dbd91.pdf',
      PNG:
        'https://a.bmstatic.com/iu/89/198/bookmate_library_EN-8bcfef09edffc6bd4f781cd4a38713e7.png',
    },
  },
  {
    img:
      'https://a.bmstatic.com/iu/227/167/bookmate_library_and_reader_EN-61eca04d83d61522fd609cd17b7d02c6.png',
    links: {
      PDF:
        'https://a.bmstatic.com/iu/172/166/bookmate_library_and_reader_EN-2256ffb7c5348bf37949fe072db5e584.pdf',
      PNG:
        'https://a.bmstatic.com/iu/227/167/bookmate_library_and_reader_EN-ec4c1bb8a970d21e5e7c8b1c33748e6f.png',
    },
  },
  {
    img:
      'https://a.bmstatic.com/iu/15/17/bookmate_library_and_reader_diagonal_EN-c7b45b82af09175d44004a4910d91501.png',
    links: {
      PDF:
        'https://a.bmstatic.com/iu/216/15/bookmate_library_and_reader_diagonal_EN-2b4d462364262c734eb7a9af4efa396b.pdf',
      PNG:
        'https://a.bmstatic.com/iu/15/17/bookmate_library_and_reader_diagonal_EN-8711ab4709402856a5cc9eb755421eef.png',
    },
  },
]

export const team = [
  'https://a.bmstatic.com/iu/88/1/image19(1)-94db4134bedb306d8234b382c2a787da.png',
  'https://a.bmstatic.com/iu/121/212/image18(1)-9c498c41850c90e8dc46084b5726a119.png',
  'https://a.bmstatic.com/iu/154/167/image17(1)-43438fa02b15c5380b1aaa28242ac1cb.png',
  'https://a.bmstatic.com/iu/188/233/image26(1)-15d2e192370570a13eaa828c3565278c.png',
  'https://a.bmstatic.com/iu/64/54/image22(1)-2f6bfd4ce8688e1ac6325b694852550c.png',
  'https://a.bmstatic.com/iu/221/188/image25(1)-e1142c362f0a5a19778941d2677c9a91.png',
  'https://a.bmstatic.com/iu/182/125/19.061(1)-b62d5a5f55015b4885a45c4c01d94cee.png',
  'https://a.bmstatic.com/iu/80/44/bookmateteam(1)-16c636e4f0903af755e8507a539733e2.png',
]

export type Asset = {
  img: string
  links: Record<string, string>
}
